import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  passportCountryData: {},
  isLoading: false,
  error: "",
  hasData: false
};
const fetchPassportCountryValiditySlice = createSlice({
  name: "passportValidity",
  initialState,
  reducers: {
    getPassportCountryListRequest: state => {
      state.isLoading = true;
    },
    getPassportCountryListSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.passportCountryData = action?.payload;
    },
    getPassportCountryListFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.error = action?.payload?.response?.data;
      state.passportCountryData = {};
    }
  }
});
export const {
  getPassportCountryListRequest,
  getPassportCountryListSuccess,
  getPassportCountryListFailure
} = fetchPassportCountryValiditySlice.actions;
export default fetchPassportCountryValiditySlice.reducer;